/* global google */
import React, { useEffect } from "react";
import { GOOGLE_CONFIG } from "config/config";

type uxModeDefinition = "popup" | "redirect";

const GoogleLoginButton = () => {
  useEffect(() => {
    // Function to initialize the Google button
    const initializeGoogleButton = () => {
      google.accounts.id.initialize({
        client_id: GOOGLE_CONFIG.clientId,
        ux_mode: GOOGLE_CONFIG.uxMode as uxModeDefinition,
        login_uri: GOOGLE_CONFIG.redirectUri,
        auto_select: true,
        context: "signin"
      });

      google.accounts.id.renderButton(document.getElementById("googleButtonId") as HTMLElement, {
        theme: "outline",
        size: "medium",
        type: "standard",
        locale: "en",
        logo_alignment: "left",
        text: "signin_with"
      });
    };

    // Check if google is already loaded
    if (typeof google !== "undefined" && google.accounts) {
      initializeGoogleButton();
    } else {
      // Wait for the script to load
      const script = document.querySelector(`script[src="https://accounts.google.com/gsi/client"]`);
      if (script) {
        script.addEventListener("load", () => {
          if (typeof google !== "undefined" && google.accounts) {
            initializeGoogleButton();
          }
        });
      }
    }
  }, []);

  return (
    <>
      <div id="googleButtonId" />
    </>
  );
};

export default GoogleLoginButton;
